import { render, staticRenderFns } from "./TabInvoices.vue?vue&type=template&id=19d7364e&"
import script from "./TabInvoices.vue?vue&type=script&lang=js&"
export * from "./TabInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports